// UseScreenSizeClass.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SetScreenSizeCssClass } from "../AppMenu/Store";

export default function useScreenSizeClass() {
  const dispatch = useDispatch();

  useEffect(() => {
    function update() {
      const w = window.innerWidth;
      const cls = w < 500 ? "mobile-screen collapsed" : w > 1200 ? "large-screen" : "small-screen";
      dispatch(SetScreenSizeCssClass(cls));
    }

    window.addEventListener("resize", update);
    update(); // initialize on mount
    return () => window.removeEventListener("resize", update);
  }, [dispatch]);
}
